import React from "react";
import ModalInfo from "../../ModalInfo";

class Page4 extends React.Component {
  state = {
    visible: true,

    age: null,
    modalShow: true,
    modalTitle: "INSTRUCTIONS",
    modalContent: (
      <div>
        <p>
          According to planned happenstance theory, there are five specific
          skills and attributes we can develop which will help us benefit from
          chance / unplanned events.
          <br />
          <br />
          Click on each description to learn more…
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 4) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">
                    Five Skills to Create Opportunities
                  </h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() =>
                      this.setState({
                        modalShow: true,
                        modalTitle: "INSTRUCTIONS",
                        modalContent: (
                          <div>
                            <p>
                              According to planned happenstance theory, there
                              are five specific skills and attributes we can
                              develop which will help us benefit from chance /
                              unplanned events.
                              <br />
                              <br />
                              Click on each description to learn more…
                            </p>
                          </div>
                        ),
                      })
                    }
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li
                      className="list-group-item form-card-selectable form-card-1 "
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Curiosity",
                          modalContent: (
                            <div>
                              <p>
                                <strong>Curiosity</strong> to want to learn new
                                things regardless of where they might lead.
                                Engaging in a variety of activities will help
                                you discover what you like and dislike.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">1</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Curiosity</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Risk-taking",
                          modalContent: (
                            <div>
                              <p>
                                <strong>Risk-taking</strong> to take action and
                                pursue an opportunity without knowing everything
                                about it.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">2</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Risk-taking</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Persistence",
                          modalContent: (
                            <div>
                              <p>
                                <strong>Persistent</strong> to keep trying, even
                                when faced with rejection or silence. Mistakes
                                and failures can provide great learning
                                experiences.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">3</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Persistence</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Optimism",
                          modalContent: (
                            <div>
                              <p>
                                <strong>Optimism</strong> to believe that
                                opportunities are within reach and that you can
                                benefit from every experience. Reality could be
                                offering you better options than you dreamed of.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">4</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Optimism</strong>
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Flexibility",
                          modalContent: (
                            <div>
                              <p>
                                <strong>Flexibility</strong> to respond to
                                change positively by adapting yourself or your
                                aims. If things don’t go according to plan, then
                                find a different path and look for new
                                opportunities as they crop up.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">5</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          <strong>Flexibility</strong>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title={this.state.modalTitle}
              content={this.state.modalContent}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page4;
